import axios from 'axios';
import { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector } from "react-redux";
import useT from '../../i18n/useT';

const AddNewTransaction = ({show, setShow, formData, setFormData, submit, loading, type}) => {
    const t = useT();
    const role = useSelector((state) => state.user.role);

    const handlers = {
        dataByVin(){
            axios(`/api/unpaid-cars?vin=${formData.vin}`)
                .then((res) => {
                    if(res.data.success){
                        const data = res.data.data[0];
                        setFormData((prev) => ({...prev, user_id: data.dealer_id, mark: data.mark, model: data.model, year: data.year, buyer: data.buyer, personal_number: data.receiver_identity_number}));
                    }else{
                        alert(t("transactions.vinNotFound"));
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }

    return(
        <Modal show={show} onHide={() => setShow(false)} size='lg' centered>
            <Modal.Header closeButton><h3>{type === "edit" ? t("transactions.editTitle") : t("transactions.addTitle")}</h3></Modal.Header>
            <Modal.Body>
                <form className='row' onSubmit={submit}>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.userId")}:</label>
                            <input name="user_id" className='form-control' type='text' required placeholder={t("transactions.enterUserId")} value={formData.user_id} onChange={(e) => setFormData((prev) => ({...prev, user_id: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.vin")}:</label>
                            <input name="vin" className='form-control' type='text' onKeyDown={(e) => {
                                if(e.keyCode == 13){
                                    e.preventDefault();
                                    handlers.dataByVin();
                                }
                            }} required placeholder={t("transactions.enterVin")} value={formData.vin} onChange={(e) => setFormData((prev) => ({...prev, vin: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.mark")}:</label>
                            <input name="mark" className='form-control' type='text' required placeholder={t("transactions.enterMark")} value={formData.mark} onChange={(e) => setFormData((prev) => ({...prev, mark: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.model")}:</label>
                            <input name="model" className='form-control' type='text' required placeholder={t("transactions.enterModel")} value={formData.model} onChange={(e) => setFormData((prev) => ({...prev, model: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.year")}:</label>
                            <input name="year" className='form-control' type='text' required placeholder={t("transactions.enterYear")} value={formData.year} onChange={(e) => setFormData((prev) => ({...prev, year: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.buyer")}:</label>
                            <input name="buyer" className='form-control' type='text' required placeholder={t("transactions.enterBuyer")} value={formData.buyer} onChange={(e) => setFormData((prev) => ({...prev, buyer: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.personalNumber")}:</label>
                            <input name="personal_number" className='form-control' type='text' required placeholder={t("transactions.enterPersonalNumber")} value={formData.personal_number} onChange={(e) => setFormData((prev) => ({...prev, personal_number: e.target.value}))}/>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.paymentType")}:</label>
                            <select className='form-control' name="payment_type" value={formData.payment_type} onChange={(e) => setFormData((prev) => ({...prev, payment_type: e.target.value}))}>
                                <option value={""}>{t("transactions.selectType")}</option>
                                <option value={"transportation"}>{t("transactions.typeTransportation")}</option>
                                <option value={"car_amount"}>{t("transactions.typeCarAmount")}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group mb-4'>
                            <label>{t("transactions.paidAmount")}:</label>
                            <input name="paid_amount" className='form-control' type='text' required placeholder={t("transactions.enterPaidAmount")} value={formData.paid_amount} onChange={(e) => setFormData((prev) => ({...prev, paid_amount: e.target.value}))}/>
                        </div>
                    </div>
                    
                    <Modal.Footer>
                        <Button type='submit' variant={loading ? 'secondary' : 'primary'} disabled={loading}>{loading ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : type === "add" ? t("common.addNew") : t("common.save")}</Button>
                        <Button type='button' onClick={() => setShow(false)} variant='danger'>{t("common.close")}</Button>
                    </Modal.Footer>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewTransaction